import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const ArticlePuff = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  ${media.mediumUp`
    flex-direction: row;
  `};
  ${media.showOutsiderAd`
    padding-right: 4px;
  `}
`;

export const ArticleLink = styled(Button).attrs(() => ({
  variant: 'text',
  color: 'link',
}))`
  padding: 0;
`;
export const TextContainer = styled.div`
  ${media.mediumUp`
    flex-basis: 60%;
  `};

  ${media.mediumUp`
    padding-left: 16px;
  `};
`;

export const ImageWrapper = styled.div`
  ${media.mediumUp`
    flex-basis: 40%;
  `}
  ${media.mediumUp`
    padding-right: 16px;
  `}
  width: 100%;
  height: 120px;
  margin-bottom: 0.5rem;
  overflow: hidden;
  position: relative;
`;

export const ImageInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
